export default {
  pageOptions: (state, options) => {
    state.options = options;
  },
  pageFilters: (state, filters) => {
    state.filters = filters;
  },
};
